var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src)?_c('img',{style:({borderRadius:_vm.radius,width:_vm.width,height:_vm.height}),attrs:{"src":_vm.handleImgSize(_vm.src,'list'),"alt":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }